import { useQuery } from "@tanstack/react-query";
import AppConstants from "../../constants/AppConstants";
import { EXPORTED_DESIGNS } from "../../constants/QueryKeys";
import UserService from "../../service/UserService";
import { getUserId } from "./useAccount";
import { STATIC_QUERY_DEFAULTS } from "../../utils/QueryUtils";

/** @typedef {import("@/types/data/ExportedDesign.mjs").ExportedDesign} ExportedDesign */
/** @typedef {{ exports: ExportedDesign[] }} ExportedDesignsData */
/**
 * @template T
 * @typedef {import("@/types/TypeUtils.mjs").QueryResultRest<T>} QueryResultRest
 */
/**
 * @template T
 * @typedef {import("@/types/TypeUtils.mjs").QueryHookOptions<T>} QueryHookOptions
 */

const defaults = { ...STATIC_QUERY_DEFAULTS, enabled: false, refetchOnMount: false };

/**
 * The user's shared design exports.
 * @param {QueryHookOptions<ExportedDesignsData>} [settings] - Extra `useQuery` options, spread over the defaults.
 * @returns {{ data: ExportedDesign[] | undefined } & QueryResultRest<ExportedDesignsData>}
 */
const useExportedDesigns = (settings = {}) => {
  const userId = getUserId();
  const { data, ...exportQuery } = useQuery({
    queryKey: [EXPORTED_DESIGNS],
    queryFn: () =>
      /** @type {Promise<ExportedDesignsData>} */ (
        UserService.loadExports(userId, AppConstants.DESIGN_TYPE_SITE)
      ),
    ...defaults,
    ...settings,
  });
  return { data: data?.exports, ...exportQuery };
};

export default useExportedDesigns;
